import React, { useState, useEffect, useCallback, useRef, use } from "react";
import { Layout, Button } from "antd";
import {
  Row,
  Form,
  Input,
  Col,
  Select,
  Collapse,
  notification,
  Popconfirm,
} from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  MinusCircleTwoTone,
  PlusCircleTwoTone,
  DeleteOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import ShelfLifeApi from "../../common/Apis/ShelfLifeApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
const OpenShelfLife = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const [formadd2] = Form.useForm();
  const { Panel } = Collapse;
  const [ShelfLife, setShelfLife] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    ShelfLifeApi.ListShelfLife(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setShelfLife(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    ShelfLifeApi.ListShelfLife(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setShelfLife(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getShelfLife = useCallback(() => {
    ShelfLifeApi.ListShelfLife(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setShelfLife(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getShelfLife();
  }, [PageLoading, getShelfLife]);

  const handleRemovefilterOpenShelfLife = (FiltergetOpenShelfLifeIndex) => {
    const newfilterOpenShelfLife = [...filterOpenShelfLife];
    newfilterOpenShelfLife.splice(FiltergetOpenShelfLifeIndex, 1);
    setFilterOpenShelfLife(newfilterOpenShelfLife);
    if (FiltergetOpenShelfLifeIndex == 0) {
    }
  };
  const handleClear = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    getShelfLife();
    setFilterOpenShelfLife([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterOpenShelfLife, setFilterOpenShelfLife] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterOpenShelfLife = () => {
    setFilterOpenShelfLife([
      ...filterOpenShelfLife,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterOpenShelfLife
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
        "componentCode=SHELF_LIFE&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setShelfLife(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FiltergetOpenShelfLifeIndex, value) => {
    const newfilterOpenShelfLife = [...filterOpenShelfLife];
    newfilterOpenShelfLife[FiltergetOpenShelfLifeIndex].title = value;
    setFilterOpenShelfLife(newfilterOpenShelfLife);

    const fieldName = 'name' + FiltergetOpenShelfLifeIndex;
    const fieldName2 = 'nameto' + FiltergetOpenShelfLifeIndex;
    formadd2.setFieldsValue({
      [fieldName]: null,
      [fieldName2]: null,
    });

  };
  const handleChangeAnswertype = (FiltergetOpenShelfLifeIndex, value) => {
    const newfilterOpenShelfLife = [...filterOpenShelfLife];
    newfilterOpenShelfLife[FiltergetOpenShelfLifeIndex].answerType = value;
    setFilterOpenShelfLife(newfilterOpenShelfLife);
  };

  const handleChangename = (FiltergetOpenShelfLifeIndex, value) => {
    const newfilterOpenShelfLife = [...filterOpenShelfLife];
    newfilterOpenShelfLife[FiltergetOpenShelfLifeIndex].name = value;
    setFilterOpenShelfLife(newfilterOpenShelfLife);
  };

  const paginatedData = ShelfLife;


  const handleDeleteShelfLife = (ShelfLifeID) => {
    ShelfLifeApi.DeleteShelfLife(ShelfLifeID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getShelfLife();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };


  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td className="pt-3">
            {item?.period}
          </td>
          <td style={{ width: "20%" }} className="pt-3">
            {item?.periodType}
          </td>

          <td style={{ width: "10%" }}>
            <div className="d-flex ">

              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Shelf Life ?"
                okText="Yes"
                onConfirm={() => handleDeleteShelfLife(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_SHELF_LIFE'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={3} className="text-center ">
            {/* <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
            /> */}
            <EmptyBox />
            <br />
            {/* <Button
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_SHELF_LIFE'
              ) ? 'btn btn-primary btn-save m-0 my-2 mt-4' : 'd-none'}
              href={"/masters/shelf-life/add-shelf-life"}
            >
              Add Shelf Life
            </Button> */}
            <Button
              type="primary"
              onClick={() => {
                navigate('/masters/shelf-life/add-shelf-life');
              }}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_SHELF_LIFE'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add New Shelf Life
            </Button>
          </td>
        </tr>
      );
    }
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            form={formadd2}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterOpenShelfLife.map(
                    (input, filterOpenShelfLifeIndex) => (
                      <div key={filterOpenShelfLifeIndex}>
                        <Row gutter={12} className="pt-2">
                          <Col span={5}>
                            <Form.Item
                              name={`title${filterOpenShelfLifeIndex}`}
                              className="text-lable"
                              rules={[
                                {
                                  required: true,
                                  message: "Please Select",
                                },
                              ]}
                            >
                              <Select
                                className="control-Select"
                                placeholder="Filter By"
                                value={input.title}
                                onChange={(value) =>
                                  handleChangeTitle(
                                    filterOpenShelfLifeIndex,
                                    value
                                  )
                                }
                                options={[
                                  {
                                    value: "period",
                                    label: "Period",
                                  },
                                  {
                                    value: "periodType",
                                    label: "Period Type",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>


                          {filterOpenShelfLife[filterOpenShelfLifeIndex].title ==
                            "periodType" ? (
                            <>

                            </>
                          ) : (
                            <>
                              <Col span={5}>
                                <Form.Item
                                  name={`type${filterOpenShelfLifeIndex}`}
                                  className="text-lable"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please Select type.",
                                    },
                                  ]}
                                >
                                  <Select
                                    className="control-Select mb-1"
                                    placeholder="Condition"
                                    onChange={(value) =>
                                      handleChangeAnswertype(
                                        filterOpenShelfLifeIndex,
                                        value
                                      )
                                    }
                                    options={[
                                      { value: "%", label: "Matches with" },
                                      {
                                        value: "=",
                                        label: "Equals to",
                                      },
                                    ]}
                                  />
                                </Form.Item>
                              </Col>
                            </>
                          )}

                          <Col span={5}>
                            {filterOpenShelfLife[filterOpenShelfLifeIndex].title ==
                              "periodType" ? (
                              <>
                                <Form.Item
                                  name={`name${filterOpenShelfLifeIndex}`}
                                  className="text-lable"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please Select Period Type.",
                                    },
                                  ]}
                                >
                                  <Select
                                    className="control-Select"
                                    placeholder="Select Period Type"
                                    onChange={(e) =>
                                      handleChangename(
                                        filterOpenShelfLifeIndex,
                                        e
                                      )
                                    }
                                  >
                                    <option value={"DAYS"}>Days</option>
                                    <option value={"WEEKS"}>Weeks</option>
                                    <option value={"MONTHS"}>Months</option>
                                    <option value={"YEARS"}>Years</option>
                                  </Select>

                                </Form.Item>
                              </>
                            ) : (
                              <>
                                <Form.Item
                                  name={`name${filterOpenShelfLifeIndex}`}
                                  className="text-lable"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter Text.",
                                    },
                                  ]}
                                >
                                  <Input
                                    type="text"
                                    onChange={(e) =>
                                      handleChangename(
                                        filterOpenShelfLifeIndex,
                                        e.target.value
                                      )
                                    }
                                    placeholder="Text"
                                    className="control-input"
                                  />
                                </Form.Item>
                              </>
                            )}
                          </Col>


                          <Col span={8}>
                            <Form.Item className="text-lable">
                              {filterOpenShelfLifeIndex == 0 ? (
                                <>
                                  <Row gutter={23} className="mb-3">
                                    <Col span={2} className="mx-0">
                                      <Form.Item className="text-lable">
                                        <PlusCircleTwoTone
                                          onClick={handleAddfilterOpenShelfLife}
                                        />
                                      </Form.Item>
                                    </Col>

                                    <Col span={10}>
                                      <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="btn btn-primary btn-save table-action icon-center "
                                      >
                                        Filter
                                      </Button>
                                    </Col>
                                    <Col span={10}>
                                      <Button
                                        type="reset"
                                        htmlType="reset"
                                        onClick={() => handleClear()}
                                        style={{ color: "#0b5ed7" }}
                                        className="btn btn-primary btn-back table-action icon-center"
                                      >
                                        Clear
                                      </Button>
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <MinusCircleTwoTone
                                    onClick={() =>
                                      handleRemovefilterOpenShelfLife(
                                        filterOpenShelfLifeIndex
                                      )
                                    }
                                  />
                                </>
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    )
                  )}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData?.length > 0 && (
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate('/masters/shelf-life/add-shelf-life');
                    }}
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_SHELF_LIFE'
                      ) ? '' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                  >
                    Add New Shelf Life
                  </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>

            <table className="table users-table">
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Period Type</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default OpenShelfLife;
